import axios from './axios';

export interface OrderItem {
  productId: number;
  productName: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  totalComparePrice: number;
  imageUrl: string;
  brandInfo: {
    id: number;
    name: string;
    nameZh: string;
    nameCn: string;
    description: string;
    descriptionZh: string;
    descriptionCn: string;
    isActive: boolean;
    imageUrl: string;
    createdAt: string;
  };
  nameZh: string;
  nameCn: string;
  descriptionZh: string;
  descriptionCn: string;
}

export interface Order {
  success: boolean;
  order: {
    id: number;
    orderNumber: string;
    status: string;
    finalTotal: number;
    customerId: string;
    paymentMethodId: number;
    createdAt: string;
    trackingNumber: string | null;
    shippingCarrier: string | null;
  };
  calculation: {
    totalItemsValue: number;
    productDiscount: number;
    salesDiscount: number;
    promoDiscount: number;
    totalDiscount: number;
    subtotal: number;
    shippingCost: number;
    taxAmount: number;
    finalTotal: number;
  };
  validatedDiscounts: {
    appliedDiscounts: Array<{
      id: number;
      code: string;
      name: string;
      value: number;
      category: string;
      appliedAt: string;
      combinable: boolean;
      description: string;
      isAutomatic: boolean;
      discountType: string;
      discountAmount: number;
      combineWithOrderDiscounts: boolean;
      combineWithProductDiscounts: boolean;
      combineWithShippingDiscounts: boolean;
    }>;
    ignoredDiscounts: unknown[];
  };
  items: OrderItem[];
  currency: string;
  shippingAddress: {
    city: string;
    email: string;
    phone: string;
    state: string;
    address: string;
    country: string;
    zipCode: string;
    lastName: string;
    apartment: string;
    firstName: string;
  };
  billingAddress: {
    city: string;
    email: string;
    phone: string;
    state: string;
    address: string;
    country: string;
    zipCode: string;
    lastName: string;
    apartment: string;
    firstName: string;
  };
  paymentMethod: {
    id: number;
    name: string;
    description: string;
    type: string;
    provider: string | null;
    iconType: string | null;
    iconName: string | null;
    isActive: boolean;
  };
}

export interface OrdersParams {
  page?: number;
  limit?: number;
  status?: string;
}

export const getOrders = async (params: OrdersParams = {}): Promise<Order[]> => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.status) queryParams.append('status', params.status.toString());

    const url = `/api/shop/orders${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    throw error;
  }
};
